export const formStackStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const infoBoxStyles = {
  display: 'flex',
  gap: '10px',
  padding: '12px 16px',
  borderRadius: '6px',
  backgroundColor: ({ palette }) => palette.info.extraSoft,
  border: ({ palette }) => `1px solid ${palette.info.soft}`,
};

export const infoIconColumnStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'flex-start',
};

export const prefillNoteStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '-8px',
};
